import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
import TestimonialCard from "./TestimonialCard";
import testimonialData from "../data/testimonialData";

const TestimonialsCarousel = () => {
  return (
    <section className="py-16 bg-red-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-6">
        <h2 className="text-sm font-semibold text-red-600 text-center mb-6">
          TESTIMONIALS
        </h2>
        
        <div className="relative">
          {/* Swiper Container with proper padding for buttons */}
          <div className="px-5 lg:px-10">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              navigation={{
                prevEl: ".testimonial-prev",
                nextEl: ".testimonial-next",
              }}
              pagination={{ 
                clickable: true, 
                el: ".testimonial-pagination",
                bulletClass: "testimonial-bullet",
                bulletActiveClass: "testimonial-bullet-active"
              }}
              autoplay={{ delay: 5000 }}
              breakpoints={{
                640: { 
                  slidesPerView: 1,
                  spaceBetween: 20
                },
                768: { 
                  slidesPerView: 2,
                  spaceBetween: 25
                },
                1024: { 
                  slidesPerView: 3,
                  spaceBetween: 30
                },
              }}
              className="testimonials-swiper"
            >
              {testimonialData.map((testimonial) => (
                <SwiperSlide key={testimonial.id}>
                  <TestimonialCard testimonial={testimonial} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Custom Navigation Buttons - Fixed Positioning */}
          <button className="testimonial-prev absolute left-2 sm:left-4 top-1/2 transform -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm hover:bg-red-50 border border-red-200 rounded-full p-3 shadow-lg hover:shadow-xl transition-all duration-300 group">
            <svg
              className="w-5 h-5 text-red-600 group-hover:text-red-700 transition-colors duration-200"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          
          <button className="testimonial-next absolute right-2 sm:right-4 top-1/2 transform -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm hover:bg-red-50 border border-red-200 rounded-full p-3 shadow-lg hover:shadow-xl transition-all duration-300 group">
            <svg
              className="w-5 h-5 text-red-600 group-hover:text-red-700 transition-colors duration-200"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>

        {/* Custom Pagination */}
        <div className="testimonial-pagination flex justify-center gap-2 mt-8" />
      </div>

      {/* Custom Styles */}
      <style jsx>{`
        .testimonials-swiper {
          overflow: hidden;
          width: 100%;
        }

        .swiper-slide {
          height: auto;
        }

        .testimonial-bullet {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: #fca5a5;
          opacity: 0.5;
          cursor: pointer;
          transition: all 0.3s ease;
          margin: 0 4px;
          display: inline-block;
        }

        .testimonial-bullet:hover {
          opacity: 0.8;
          transform: scale(1.1);
        }

        .testimonial-bullet-active {
          background-color: #dc2626;
          opacity: 1;
          transform: scale(1.2);
        }

        /* Remove default swiper button styles */
        .testimonials-swiper :global(.swiper-button-next),
        .testimonials-swiper :global(.swiper-button-prev) {
          display: none;
        }

        .testimonials-swiper :global(.swiper-pagination) {
          display: none;
        }

        /* Mobile responsiveness */
        @media (max-width: 640px) {
          .testimonial-prev,
          .testimonial-next {
            padding: 8px;
            transform: translateY(-50%) scale(0.9);
          }
          
          .testimonial-prev {
            left: 8px;
          }
          
          .testimonial-next {
            right: 8px;
          }
        }
      `}</style>
    </section>
  );
};

export default TestimonialsCarousel;